import React from 'react'
import Navbar from '../components/Navbar/Navbar'
import Footer from '../components/Footer/Footer'
import BlogDetails from './BlogDetails'

const Blogdetailspage = () => {
  return (
    <div>
        <Navbar/>

        <BlogDetails/>


        <Footer/>

    </div>
  )
}

export default Blogdetailspage
